// Hash router — works on any static host and survives kiosk reloads.

import { useSyncExternalStore } from 'react';

export interface Route {
  path: string;
  segments: string[];
  query: URLSearchParams;
}

function parse(): Route {
  const raw = location.hash.replace(/^#/, '') || '/';
  const [path, qs = ''] = raw.split('?');
  const clean = '/' + path.replace(/^\/+|\/+$/g, '');
  return { path: clean, segments: clean.split('/').filter(Boolean), query: new URLSearchParams(qs) };
}

let current = parse();
const listeners = new Set<() => void>();
window.addEventListener('hashchange', () => {
  current = parse();
  for (const l of listeners) l();
});

export function useRoute(): Route {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => current,
  );
}

export function navigate(path: string, opts: { replace?: boolean } = {}) {
  const target = '#' + path;
  if (opts.replace) {
    history.replaceState(null, '', target);
    current = parse();
    for (const l of listeners) l();
  } else if (location.hash !== target) location.hash = path;
}

export function currentRoute(): Route {
  return current;
}
